import { brand } from '@/config/brands'
import { useUserStore } from '@/stores'

declare const window: Window & { dataLayer?: any[] }

/**
 * 构造 Axon user_data: email 优先真实邮箱,无则用 {memberId}@{品牌小写}.com 构造;
 * Applovin 要求 email 小写,并会在服务端自动 SHA-256,前端无需 hash
 */
function getAxonUserData(): { email: string; user_id: string } | undefined {
  try {
    const { email, memberId } = useUserStore().$state
    if (!memberId)
      return undefined
    return {
      email: (email || `${memberId}@${brand.toLowerCase()}.com`).toLowerCase(),
      user_id: String(memberId),
    }
  }
  catch {
    return undefined
  }
}

export function pushAxonEvent(eventName: string, params: Record<string, any>, options: Record<string, any> = {}) {
  window.dataLayer = window.dataLayer || []

  if (params.items !== undefined)
    window.dataLayer.push({ items: null })

  const userData = getAxonUserData()
  window.dataLayer.push({
    event: eventName,
    ...(userData ? { user_data: userData } : {}),
    ...params,
    ...options,
  })
}

/**
 * Applovin CSV feed 要求: item_id=父商品(充值 payConfigId/订阅 subscribeConfigId), item_variant_id=productId 全局唯一;
 * configId 为空时回退 productId,保证在途旧链路 purchase 不丢 item_id;
 * 'undefined'/'null' 字符串可能经 URL 参数透传进来,同样视为空值
 */
export function buildAxonItem(configId: string | number | undefined, productId: string | number, productName: string, price: string | number) {
  const validConfigId = configId && configId !== 'undefined' && configId !== 'null' ? configId : ''
  return {
    item_id: String(validConfigId || productId),
    item_variant_id: String(productId),
    item_name: productName,
    price: Number(price),
    quantity: 1,
  }
}
